/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import BackfillModel from 'cio/models/backfill';

interface BackfillRowSignature {
  Args: {
    backfill: BackfillModel;
    onExpand: () => unknown;
    onCollapse: () => unknown;
    isExpanded: boolean;
  };
  Element: HTMLTableRowElement;
}

export default class BackfillRow extends Component<BackfillRowSignature> {
  @action
  toggleExpand() {
    if (this.args.isExpanded) {
      this.args.onCollapse();
    } else {
      this.args.onExpand();
    }
  }
}
